import { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TopBar } from './Main/Shared/TopBar';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { updateMetaData, deletePattern } from '../utils/email';
import { getURLFromFileNameAndMediaToken } from '../utils/url';
import { AuthContext } from '../providers/AuthProvider';
import DoneIcon from '@mui/icons-material/Done';
import Button from '@mui/material/Button';
import { buttonTypographySx } from '../styles/patterns';

// TODO: Instead of building URL from params, get PDF from storage and use that to decide if metadata should be updated
// TODO: This can be cheaper as we'll only write when necessary if the website is opened multiple times
export const SinglePattern = () => {
	const { user } = useContext(AuthContext);
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const n = searchParams.get('n');
	const mt = searchParams.get('mt');

	const getURL = () =>
		!n || !mt ? '' : getURLFromFileNameAndMediaToken(n, mt);

	useEffect(() => {
		if (!n) {
			navigate('/');
			return;
		}

		// delete PDF from storage
		if (!mt) {
			deletePattern(n, () => navigate('/'));
			return;
		}

		// set pdf as paid
		updateMetaData(n, { paid: 'true' });
	}, [n, mt, navigate, user?.uid]);

	return (
		<>
			<Container
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					height: '100vh',
				}}
			>
				<TopBar />
				{mt && (
					<>
						<Typography
							variant="h4"
							sx={{ textAlign: 'center', mt: '16px' }}
						>
							🎉 Here is your pattern! 🎉
						</Typography>
						<Typography
							variant="h6"
							gutterBottom
							sx={{ textAlign: 'center' }}
						>
							Download your pattern and start creating Fore Edge
							Book Art!
						</Typography>

						<Button
							href={getURL()}
							target="_blank"
							variant="contained"
							size="small"
							color="primary"
							download
							endIcon={<DoneIcon />}
							sx={{ margin: '10px' }}
						>
							<Typography variant="h5" sx={buttonTypographySx}>
								Open
							</Typography>
						</Button>

						<iframe
							src={getURL()}
							title="Pattern PDF"
							style={{
								flexGrow: 1,
								width: '100%',
							}}
						/>
					</>
				)}
			</Container>
		</>
	);
};
